// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__33-Z6","approved":"Status_approved__IYKt1","rejected":"Status_rejected__1GWH3","expired":"Status_expired__1p5_Q","label":"Status_label__Hc6Te"};